import Ayuda from '../ui/Ayuda';
import { sinConfirmar } from './hojasDeEtiquetas';

// EL SELECTOR DE HOJA DE ETIQUETAS · U-02 fase a (DISEÑO §6.1).
//
// Vive en el carril y lo pinta el modal de `paginas/Etiquetas.jsx`: así el
// parche a la pantalla ajena es corto (D19) y las reglas —qué hoja se
// ofrece, qué se avisa, qué hace la hoja de prueba— están en un solo sitio.
//
// `formatos` llega YA filtrado (`hojasOfrecidas`): aquí no se decide qué se
// ofrece, solo cómo se pinta.
//
// LA HOJA DE PRUEBA NO ES «SOLO LOS CONTORNOS». El servidor dibuja el
// contorno de cada hueco ENCIMA de las etiquetas (ENTREGA ACCESOS-U-02a,
// «Decisiones tomadas al construir»): a contraluz se ve también si el QR
// cae dentro. El texto de la casilla dice eso, y no lo que el diseño
// suponía, para que nadie espere una hoja en blanco con rayas.
//
// 320 px: cada opción a lo ancho, apilada, con su objetivo de 44 px; los
// textos largos (nombre, referencia) se parten en vez de empujar la caja.
export default function ElegirHoja({ formatos, elegido, onElegir, contornos, onContornos }) {
  const formato = formatos.find((f) => f.codigo === elegido);

  return (
    <div className="space-y-3 min-w-0">
      <fieldset className="space-y-2 min-w-0">
        <legend className="text-sm font-semibold text-gray-900">
          ¿En qué hoja de etiquetas vas a imprimir?
        </legend>
        <Ayuda id="etiquetas.hoja.elegir" />
        {formatos.map((f) => (
          <label key={f.codigo}
                 data-hoja={f.codigo}
                 className={`block min-h-11 rounded-lg border p-3 cursor-pointer ${
                   elegido === f.codigo
                     ? 'border-[var(--color-marca)] bg-blue-50'
                     : 'border-gray-200 hover:border-gray-400'}`}>
            <span className="flex items-start gap-2 min-w-0">
              <input type="radio" name="formato" value={f.codigo}
                     checked={elegido === f.codigo} className="mt-1 h-5 w-5 shrink-0"
                     onChange={() => onElegir(f.codigo)} />
              <span className="min-w-0 break-words">
                <span className="block text-sm font-semibold text-gray-900">
                  {f.nombre}
                </span>
                {f.referencia_comercial && (
                  <span className="block text-xs text-gray-700">{f.referencia_comercial}</span>
                )}
                {f.descripcion && (
                  <span className="block text-xs text-gray-500">{f.descripcion}</span>
                )}
                <span className={`block text-xs mt-0.5 ${
                  f.lleva_codigo_de_barras ? 'text-gray-600' : 'text-amber-700'}`}>
                  {f.lleva_codigo_de_barras
                    ? 'Lleva el QR y el código de barras dibujado.'
                    : 'Solo el QR: en esta medida, el código de barras saldría ilegible.'}
                </span>
                {sinConfirmar(f) && (
                  <span data-sin-confirmar
                        className="mt-1 inline-block rounded bg-amber-100 px-1.5 py-0.5 text-[11px] font-semibold text-amber-900">
                    Medidas sin confirmar
                  </span>
                )}
              </span>
            </span>
          </label>
        ))}
      </fieldset>

      {/* EL AVISO VA PEGADO A LA DECISIÓN QUE CAMBIA: con la hoja elegida
          sin confirmar, se dice qué hacer antes de gastar etiquetas. */}
      {sinConfirmar(formato) && (
        <div role="note" data-aviso-sin-confirmar
             className="rounded-lg border border-amber-200 bg-amber-50 p-2.5 text-sm text-amber-900">
          <strong className="block">Medidas sin confirmar</strong>
          <Ayuda id="etiquetas.hoja.sin_confirmar" />
        </div>
      )}

      <label className="flex min-h-11 items-start gap-2 rounded-lg border border-gray-200 p-3 cursor-pointer">
        <input type="checkbox" checked={contornos} onChange={(e) => onContornos(e.target.checked)}
               className="mt-0.5 h-5 w-5 shrink-0" />
        <span className="min-w-0">
          <span className="block text-sm font-semibold text-gray-900">
            Hoja de prueba: con el contorno de cada etiqueta encima
          </span>
          <Ayuda id="etiquetas.hoja.prueba" />
        </span>
      </label>

      <details className="text-sm text-gray-700">
        <summary className="min-h-11 cursor-pointer py-2 font-semibold">
          Cómo se acomodan las etiquetas en la hoja
        </summary>
        <Ayuda id="etiquetas.hoja.ficha" />
      </details>
    </div>
  );
}
